export { InspectionType, PayerType, PaymentMethod } from '@comparaonline/cicl-funnel-schema';

export { StepIds } from './stepIds';
export { Banks } from './banks';
export { CarStatus } from './car';

import * as FieldNames from './FieldNames';
import * as Sections from './sections';

export { FieldNames, Sections };
